<span class="close-icon" [mat-dialog-close]="">
  <mat-icon>close</mat-icon>
</span>
<h2 mat-dialog-title>
  {{ "brand.partnerImportList.confirmDialog.title" | translate }}
</h2>
<mat-dialog-content>
  <div class="content">
    <span>
      {{ "brand.partnerImportList.confirmDialog.description" | translate }}
    </span>
    <div class="cases">
      @if (data.errors) {
        <span
          ><strong>{{ data.errors }}</strong>
          {{
            "brand.partnerImportList.confirmDialog.entriesHadErrors" | translate
          }}
        </span>
      }
      @if (data.multipleSelections) {
        <span>
          <strong>{{ data.multipleSelections }}</strong>
          {{
            "brand.partnerImportList.confirmDialog.repeatedPartners" | translate
          }}
        </span>
      }
      @if (data.alreadyJoined) {
        <span>
          <strong>{{ data.alreadyJoined }}</strong>
          {{
            "brand.partnerImportList.confirmDialog.alreadyImported" | translate
          }}
        </span>
      }
      @if (data.skipped) {
        <span
          ><strong>{{ data.skipped }}</strong>
          {{ "brand.partnerImportList.confirmDialog.skipped" | translate }}
        </span>
      }
    </div>
    <strong>
      {{
        "brand.partnerImportList.confirmDialog.importedResult"
          | translate: { number: data.toImport }
      }}
    </strong>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (data.toImport > 0) {
    <button class="btn btn--transparent" [mat-dialog-close]="false">
      {{ "shared.cancel" | translate }}
    </button>
    <button class="btn btn--primary" (click)="continue()">
      {{ "shared.accept" | translate }}
    </button>
  } @else {
    <button class="btn btn--primary" [mat-dialog-close]="false">
      {{ "shared.ok" | translate }}
    </button>
  }
</mat-dialog-actions>
